/**
 * Created by intellicar-rinas on 8/1/18.
 */
import React, {Component} from 'react';
import './CompactorView2.css';
import Dom from '../../../../helpers/Dom';
import eStopIcon from '../../../../assets/svg/paver/estop.svg';
import coolantIcon from '../../../../assets/svg/paver/coolant.svg';
import lubeOilIcon from '../../../../assets/svg/paver/lubeoil.svg';
import airFilterIcon from '../../../../assets/svg/paver/airfilter.svg';
import engineIcon from '../../../../assets/svg/compactor/engine.svg';
import ignition2Icon from '../../../../assets/svg/compactor/ignition.svg';
import vibrationIcon from '../../../../assets/svg/compactor/vibration.svg';
import vibrationRedIcon from '../../../../assets/svg/compactor/vibration-red.svg';
import eStopActiveIcon from '../../../../assets/svg/paver/estopActive.svg';
import coolantActiveIcon from '../../../../assets/svg/paver/coolantActive.svg';
import lubeOilActiveIcon from '../../../../assets/svg/paver/lubeoilActive.svg';
import airFilterActiveIcon from '../../../../assets/svg/paver/airfilterActive.svg';
import engineActiveIcon from '../../../../assets/svg/compactor/engineActive.svg';
import ignition2ActiveIcon from '../../../../assets/svg/compactor/ignitionActive.svg';
import vibrationActiveIcon from '../../../../assets/svg/compactor/vibrationActive.svg';
import batteryIcon from '../../../../assets/svg/paver/battery.png';
import logo from '../../../../assets/svg/paver/logo.png';
import {dateFormat} from '../../../../constants/constants';
import moment from 'moment';
import InPieChart from '../../../ReportWindow/schema/InPieChart/InPieChart';
import ReportAPIs from '../../../../APIs/ReportAPIs';

class PaverView extends  Component {

    state = {
        vehicle:{
            stats:{},
            vehiclemeta:{}
        }
    }

    constructor() {
        super();

        this.updateView =()=> {
            if(this.props && this.props.vehicle) {
                this.setState({vehicle: this.props.vehicle()});
            }
            this.forceUpdate();
            this.getData();
        };

        this.isSimulating =()=> {
            return window.getMQTTSimulationStatus ? window.getMQTTSimulationStatus() : false;
        };

        this.toggleSimulation =()=> {
            if(window.getMQTTSimulationStatus) {
                let status = window.getMQTTSimulationStatus();
                if(status) {
                    window.stopMQTTSimulation()
                } else {
                    window.startMQTTSimulation()
                }
                setTimeout(()=>this.forceUpdate(), 200);
            }
        };

        this.clearState =(callback)=> {
            this.setState({stats:{}, can2:{}, vehicle:{}}, callback);
        };

        this.getTime =()=> {
            return this.state.vehicle && this.state.vehicle.stats && moment(this.state.vehicle.stats.time).format(dateFormat);
        };

        this.get =key=> {
            if(!this.state.vehicle) return null;

            if(this.state.vehicle.can2 && key in this.state.vehicle.can2) {
                return this.state.vehicle.can2[key]
            }
            if(this.state.data && key in this.state.data) {
                return this.state.data[key]
            }
            if(this.state.vehicle && key in this.state.vehicle) {
                return this.state.vehicle[key];
            }
            if(this.state.vehicle.stats && key in this.state.vehicle.stats) {
                return this.state.vehicle.stats[key];
            }
            if(this.state.vehicle.vehiclemeta && key in this.state.vehicle.vehiclemeta) {
                return this.state.vehicle.vehiclemeta[key]
            }
            if(this.state.vehicle && key in this.state.vehicle) {
                return this.state.vehicle[key]
            }
        };

        this.isSimulating =()=> {
            return window.getMQTTSimulationStatus ? window.getMQTTSimulationStatus() : false;
        };

        this.toggleSimulation =()=> {
            if(window.getMQTTSimulationStatus) {
                let status = window.getMQTTSimulationStatus();
                if(status) {
                    window.stopMQTTSimulation()
                } else {
                    window.startMQTTSimulation()
                }
                setTimeout(()=>this.forceUpdate(), 200);
            }
        }

        this.getPieConfig =index=> {
            return {}
        };

        this.getData = () => {

            if(!this.props.vehicle)
                return;

            let today = moment(Date.now()).startOf('day');
            let body = {
                vehicleid:this.props.vehicle().vehicleid,
                starttime:today.unix() * 1000,
                endtime:today.add(24, 'hours').unix() * 1000
            };

            const handleFailure =()=> { console.log("PaverScreen: Fetching data failed") };

            ReportAPIs.getVolvoCompactorMetrics(body)
                .then(resp=>{
                    this.setState({data:resp})
                }, handleFailure)

        }
    }

    // airfilterclogcount -----------------
    // enginecoolanttempcount -----------------
    // engineoilpresscount -----------------
    // estopcount -----------------
    // lowrpmcount -----------------
    // parkbrakecount -----------------
    // seatswithopencount -----------------

    // distance
    // fuelconsumed

    // batterychargingtime
    // highvibrationtime
    // hourend
    // hourstart
    // idletime
    // lowvibrationtime
    // stoppagetime
    // totalhours
    // travelwithoutvibration
    // vibrationtimefwd
    // vibrationtimereverse

    render() {
        return (
            <div className="PaverView -compactor">
                <div className={"pv-sim-button "+(this.isSimulating() ? 'active': '')} onClick={()=>this.toggleSimulation()}>SIM</div>
                <div className="pv-header">
                    <div className="pvh-desc1">VOLVO COMPACTOR</div>
                    <div className="pvh-desc2">{this.get('modelnumbermsb')}</div>
                    <div className="pvh-desc3">{this.state.vehicle.vehicleno}</div>
                    <img src={logo}/>
                    <div className="pvh-time">
                        <span className="pvht-icon"></span>
                        <span className="pvht-1">Last seen on</span>
                        <span className="pvht-2">{this.getTime()}</span>
                    </div>
                </div>
                <div className="pv-digitalBlock">
                    <div className="pvdb-top">
                        <div className="pvdbt-bar">
                            <div className="pvdbtb-value">{this.get('rpm')}</div>
                            <div className="pvdbtb-name">RPM x100</div>
                            <div className="pvdbtb-tick pvdbtb-tick-1">0</div>
                            <div className="pvdbtb-tick pvdbtb-tick-2">6</div>
                            <div className="pvdbtb-tick pvdbtb-tick-3">12</div>
                            <div className="pvdbtb-tick pvdbtb-tick-4">18</div>
                            <div className="pvdbtb-tick pvdbtb-tick-5">26</div>
                            <div className="pvdbtb-tick pvdbtb-tick-6">30</div>
                            <div className="pvdbtb-progress">
                                <div className="pvdbtbp-overlay"></div>
                                <div className="pvdbtbp-fill" style={{width:(this.get('rpm') * 100 / 3000)+ '%'}}><div className="pvdbtbpf-shade"></div></div>
                            </div>
                        </div>
                        <div className="pvdbt-bar">
                            <div className="pvdbtb-value">{this.get('speed')}<span>mpm</span></div>
                            <div className="pvdbtb-name">SPEED</div>
                            <div className="pvdbtb-tick pvdbtb-tick-1">0</div>
                            <div className="pvdbtb-tick pvdbtb-tick-2">20</div>
                            <div className="pvdbtb-tick pvdbtb-tick-3">40</div>
                            <div className="pvdbtb-tick pvdbtb-tick-4">60</div>
                            <div className="pvdbtb-tick pvdbtb-tick-5">80</div>
                            <div className="pvdbtb-tick pvdbtb-tick-6">100</div>
                            <div className="pvdbtb-progress">
                                <div className="pvdbtbp-overlay"></div>
                                <div className="pvdbtbp-fill" style={{width:this.get('speed') + '%'}}><div className="pvdbtbpf-shade"></div></div>
                            </div>
                        </div>
                    </div>
                    <div className="pvdb-bottom">
                        <div className={"pvdbb-item "+(this.get('ignition') ? 'active' : '')}>
                            <div className="pvdbbi-body">
                                {this.get('ignition') ? <object data={ignition2ActiveIcon}></object> : <object data={ignition2Icon}></object>}
                            </div>
                            <div className="pvdbbi-name">IGNITION</div>
                        </div>
                        <div className={"pvdbb-item "+(this.get('engineStatus') ? 'active' : '')}>
                            <div className="pvdbbi-body">
                                {this.get('engineStatus') ? <object data={engineActiveIcon}></object> : <object data={engineIcon}></object>}
                            </div>
                            <div className="pvdbbi-name">ENGINE</div>
                        </div>
                        <div className={"pvdbb-item "+(this.get('engineCoolentTemp') ? 'active' : '')}>
                            <div className="pvdbbi-body">
                                {this.get('engineCoolentTemp') ? <object data={coolantActiveIcon}></object> : <object data={coolantIcon}></object>}
                            </div>
                            <div className="pvdbbi-name">HIGH COOLANT</div>
                        </div>
                        <div className={"pvdbb-item "+(this.get('eStop') ? 'active' : '')}>
                            <div className="pvdbbi-body">
                                {this.get('eStop') ? <object data={eStopActiveIcon}></object> : <object data={eStopIcon}></object>}
                            </div>
                            <div className="pvdbbi-name">E-STOP</div>
                        </div>
                        <div className={"pvdbb-item "+(this.get('engineOilPressure') ? 'active' : '')}>
                            <div className="pvdbbi-body">
                                {this.get('engineOilPressure') ? <object data={lubeOilActiveIcon}></object> : <object data={lubeOilIcon}></object>}
                            </div>
                            <div className="pvdbbi-name">LUBE OIL PRESSURE</div>
                        </div>
                        <div className={"pvdbb-item "+(this.get('airFilterClogIndicator') ? 'active' : '')}>
                            <div className="pvdbbi-body">
                                {this.get('airFilterClogIndicator') ? <object data={airFilterActiveIcon}></object> : <object data={airFilterIcon}></object>}
                            </div>
                            <div className="pvdbbi-name">AIR FILTER CLOGGED</div>
                        </div>
                        <div className={"pvdbb-item "+(this.get('vibrationStatus') == 1 ?  ' active ' : this.get('vibrationStatus') == 2 ?  ' active -red ' : '')}>
                            <div className="pvdbbi-body">
                                {this.get('vibrationStatus') == 2 ? (
                                    <object data={vibrationRedIcon}></object>
                                ) : this.get('vibrationStatus') == 1 ? (
                                    <object data={vibrationActiveIcon}></object>
                                ) : (
                                    <object data={vibrationIcon}></object>
                                )}
                            </div>
                            <div className="pvdbbi-name">{
                                this.get('vibrationStatus') == 1 ?  'LOW VIBRATION' : this.get('vibrationStatus') == 2 ?  'HIGH VIBRATION' : 'NO VIBRATION'
                            }</div>
                        </div>
                        <div className={"pvdbb-item "+(this.get('machineMovement') == 1 ?  ' active ' : this.get('machineMovement') == 2 ?  ' -red ' : '')}>
                            <div className="pvdbbi-body -letterIcon">
                                <span>{ this.get('machineMovement') == 1 ?  'R' : this.get('machineMovement') == 2 ?  'F' : 'N' }</span>
                            </div>
                            <div className="pvdbbi-name">NEUTRAL</div>
                        </div>
                    </div>
                </div>

                <div className="pv-block pv-separator -small">
                    <div className="pv-body">
                        REAL TIME
                    </div>
                </div>

                <div className="pv-block pv-squareBlock">
                    <div className="pvb4-item">
                        <div className="pv-body">
                            <div className="pvsb-desc1">BATTERY</div>
                            <div className="pvsb-desc2">{parseFloat(this.get('batteryVoltage')).toFixed(1)}<span>v</span></div>
                            {
                                this.get('chargingStatus') ? (
                                    <div className="pvsb-desc3">
                                        <img src={batteryIcon}/>
                                        <span>CHARGING</span>
                                    </div>
                                ) : null
                            }
                        </div>
                    </div>
                    <div className="pvb4-item">
                        <div className="pv-body">
                            <div className="pvsb-desc1">FUEL LEVEL</div>
                            <div className="pvsb-desc2">{parseFloat(this.get('fuelLevel')).toFixed(1)}<span>Ltr</span></div>
                        </div>
                    </div>
                    <div className="pvb4-item">
                        <div className="pv-body">
                            <div className="pvsb-desc1">FUEL CONSUMED</div>
                            <div className="pvsb-desc2">{this.get('fuelconsumed')}<span>Ltr</span></div>
                        </div>
                    </div>
                </div>

                <div className="pv-block pv-separator -small">
                    <div className="pv-body">
                        DAILY DISTANCE STATS
                    </div>
                </div>

                <div className="pv-block pv-squareBlock">
                    <div className="pvb4-item">
                        <div className="pv-body">
                            <div className="pvsb-desc1">DISTANCE</div>
                            <div className="pvsb-desc2">{this.get('distance')}<span>km</span></div>
                        </div>
                    </div>
                    <div className="pvb4-item">
                        <div className="pv-body">
                            <div className="pvsb-desc1">TRAVEL W/O VIBRATION</div>
                            <div className="pvsb-desc2">{this.get('travelwithoutvibration')}<span>m</span></div>
                        </div>
                    </div>
                </div>

                <div className="pv-block pv-separator -small">
                    <div className="pv-body">
                        DAILY DURATION STATS
                    </div>
                </div>

                <div className="pv-block pv-squareBlock">
                    <div className="pvb4-item">
                        <div className="pv-body">
                            <div className="pvsb-desc1">MACHINE HMR</div>
                            <div className="pvsb-desc2">{parseInt(this.get('hourMeter'))}<span>hrs</span></div>
                        </div>
                    </div>
                    <div className="pvb4-item">
                        <div className="pv-body">
                            <div className="pvsb-desc1">LOW VIBRATION TIME</div>
                            <div className="pvsb-desc2">{this.get('lowvibrationtime')}<span>min</span></div>
                        </div>
                    </div>
                    <div className="pvb4-item">
                        <div className="pv-body">
                            <div className="pvsb-desc1">HIGH VIBRATION TIME</div>
                            <div className="pvsb-desc2">{this.get('highvibrationtime')}<span>min</span></div>
                        </div>
                    </div>
                    <div className="pvb4-item">
                        <div className="pv-body">
                            <div className="pvsb-desc1">BATTERY CHARGING TIME</div>
                            <div className="pvsb-desc2">{this.get('batterychargingtime')}<span>min</span></div>
                        </div>
                    </div>
                </div>
                <div className="pv-block pv-squareBlock">
                    <div className="pvb4-item">
                        <div className="pv-body">
                            <div className="pvsb-desc1">HOUR END</div>
                            <div className="pvsb-desc2">{this.get('hourend')}<span>hrs</span></div>
                        </div>
                    </div>
                    <div className="pvb4-item">
                        <div className="pv-body">
                            <div className="pvsb-desc1">HOUR START</div>
                            <div className="pvsb-desc2">{this.get('hourstart')}<span>hrs</span></div>
                        </div>
                    </div>
                    <div className="pvb4-item">
                        <div className="pv-body">
                            <div className="pvsb-desc1">IDLE TIME</div>
                            <div className="pvsb-desc2">{this.get('idletime')}<span>min</span></div>
                        </div>
                    </div>
                    <div className="pvb4-item">
                        <div className="pv-body">
                            <div className="pvsb-desc1">STOPPAGE TIME</div>
                            <div className="pvsb-desc2">{this.get('stoppagetime')}<span>min</span></div>
                        </div>
                    </div>
                </div>
                <div className="pv-block pv-squareBlock">
                    <div className="pvb4-item">
                        <div className="pv-body">
                            <div className="pvsb-desc1">TOTAL HOURS</div>
                            <div className="pvsb-desc2">{this.get('totalhours')}<span>hrs</span></div>
                        </div>
                    </div>
                    <div className="pvb4-item">
                        <div className="pv-body">
                            <div className="pvsb-desc1">VIBRATION TIME FORWARD</div>
                            <div className="pvsb-desc2">{this.get('vibrationtimefwd')}<span>min</span></div>
                        </div>
                    </div>
                    <div className="pvb4-item">
                        <div className="pv-body">
                            <div className="pvsb-desc1">VIBRATION TIME REVERSE</div>
                            <div className="pvsb-desc2">{this.get('vibrationtimereverse')}<span>min</span></div>
                        </div>
                    </div>
                </div>

                <div className="pv-block pv-separator -small">
                    <div className="pv-body">
                        DAILY ALARM COUNT
                    </div>
                </div>

                <div className="pv-block pv-squareBlock">
                    <div className="pvb4-item">
                        <div className="pv-body">
                            <div className="pvsb-desc1">AIR FILTER CLOGGED</div>
                            <div className="pvsb-desc2">{this.get('airfilterclogcount')}<span></span></div>
                        </div>
                    </div>
                    <div className="pvb4-item">
                        <div className="pv-body">
                            <div className="pvsb-desc1">ENGING COOLENT TEMP</div>
                            <div className="pvsb-desc2">{this.get('enginecoolanttempcount')}<span></span></div>
                        </div>
                    </div>
                    <div className="pvb4-item">
                        <div className="pv-body">
                            <div className="pvsb-desc1">ENGING OIL PRESSURE</div>
                            <div className="pvsb-desc2">{this.get('engineoilpresscount')}<span></span></div>
                        </div>
                    </div>
                    <div className="pvb4-item">
                        <div className="pv-body">
                            <div className="pvsb-desc1">E STOP</div>
                            <div className="pvsb-desc2">{this.get('estopcount')}<span></span></div>
                        </div>
                    </div>
                </div>
                <div className="pv-block pv-squareBlock">
                    <div className="pvb4-item">
                        <div className="pv-body">
                            <div className="pvsb-desc1">PARKING BRAKE</div>
                            <div className="pvsb-desc2">{this.get('parkbrakecount')}<span></span></div>
                        </div>
                    </div>
                    <div className="pvb4-item">
                        <div className="pv-body">
                            <div className="pvsb-desc1">DRIVER NOT SEATED</div>
                            <div className="pvsb-desc2">{this.get('seatswithopencount')}<span></span></div>
                        </div>
                    </div>
                    <div className="pvb4-item">
                        <div className="pv-body">
                            <div className="pvsb-desc1">LOW RPM</div>
                            <div className="pvsb-desc2">{this.get('lowrpmcount')}<span></span></div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}
export default PaverView;